import { render, staticRenderFns } from "./GuideTreeItemCard.vue?vue&type=template&id=36683143&scoped=true&"
import script from "./GuideTreeItemCard.vue?vue&type=script&lang=js&"
export * from "./GuideTreeItemCard.vue?vue&type=script&lang=js&"
import style0 from "./GuideTreeItemCard.vue?vue&type=style&index=0&id=36683143&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36683143",
  null
  
)

export default component.exports